module.exports = __webpack_public_path__ + "static/media/Circo2024_27.8cf1a90b.webp";